export const SHOW = 'hall/modal/SHOW'
export const PERSIST = 'hall/modal/PERSIST'
export const DISMISS = 'hall/modal/DISMISS'
export const SET_STATE = 'hall/modal/SET_STATE'
